// extracted by mini-css-extract-plugin
module.exports = {"wrpr":"LinkBlock_wrpr__A0T_W","ttl":"LinkBlock_ttl__GVG0I","layout":"LinkBlock_layout__YfUC9","list":"LinkBlock_list__nH77C","links":"LinkBlock_links__Y_XCP"};